var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-row", [
        _c(
          "div",
          { staticClass: "power-job-button" },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary" },
                on: { click: _vm.fetchInstanceDetail },
              },
              [_vm._v("刷新")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "power-job-info",
          style: { width: _vm.fixedWidth ? _vm.fixedWidth : "100%" },
        },
        [
          _c(
            "el-card",
            [
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c("span", { staticClass: "power-job-text" }, [
                      _vm._v("任务实例ID:"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.instanceId)),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c("span", { staticClass: "power-job-text" }, [
                      _vm._v("状态:"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "title" }, [
                      _vm._v(
                        _vm._s(
                          _vm.translateInstanceStatus(_vm.instanceDetail.status)
                        )
                      ),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c("span", { staticClass: "power-job-text" }, [
                      _vm._v("运行次数:"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.instanceDetail.runningTimes)),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c("span", { staticClass: "power-job-text" }, [
                      _vm._v("TaskTracker地址:"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.instanceDetail.taskTrackerAddress)),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c("span", { staticClass: "power-job-text" }, [
                      _vm._v("预计执行时间:"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.instanceDetail.expectedTriggerTime)),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c("span", { staticClass: "power-job-text" }, [
                      _vm._v("开始时间:"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.instanceDetail.actualTriggerTime)),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c("span", { staticClass: "power-job-text" }, [
                      _vm._v("结束时间:"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.instanceDetail.finishedTime)),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c("span", { staticClass: "power-job-text" }, [
                      _vm._v("节点参数:"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.instanceDetail.jobParams)),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c("span", { staticClass: "power-job-text" }, [
                      _vm._v("任务实例参数:"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.instanceDetail.instanceParams)),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c(
                      "div",
                      {
                        class: {
                          "power-job-result": true,
                          "power-job-result-detail": _vm.resultAll,
                        },
                      },
                      [
                        _c("span", { staticClass: "power-job-text" }, [
                          _vm._v("任务结果:"),
                        ]),
                        _vm._v(" "),
                        !_vm.resultAll
                          ? _c(
                              "el-popover",
                              {
                                attrs: {
                                  width: "400",
                                  placement: "right",
                                  trigger: "click",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "reference",
                                      fn: function () {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "power-job-content",
                                              style: {
                                                width: _vm.fixedWidth
                                                  ? _vm.fixedWidth - 200 + "px"
                                                  : "400px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.instanceDetail.result
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  2369895198
                                ),
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "power-job-content-slot" },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.instanceDetail.result) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.resultAll
                          ? _c("span", { staticClass: "title" }, [
                              _vm._v(_vm._s(_vm.instanceDetail.result)),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _vm._t("default"),
              _vm._v(" "),
              _vm.instanceDetail.taskDetail
                ? _c("el-row", { attrs: { id: "taskDetail" } }, [
                    _c("span", { staticClass: "power-job-text" }, [
                      _vm._v("Task信息:"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.instanceDetail.taskDetail)),
                    ]),
                  ])
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.instanceDetail.subInstanceDetails
        ? _c("el-divider", { attrs: { "content-position": "center" } }, [
            _vm._v("最近10条秒级任务历史记录"),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.instanceDetail.subInstanceDetails
        ? _c(
            "div",
            {
              staticClass: "power-job-info",
              style: { width: _vm.fixedWidth ? _vm.fixedWidth : "100%" },
            },
            [
              _c(
                "el-card",
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.instanceDetail.subInstanceDetails,
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": true,
                              prop: "subInstanceId",
                              label: "子任务实例ID",
                              width: "120",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": true,
                              prop: "startTime",
                              label: "开始时间",
                              width: "160",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": true,
                              prop: "finishedTime",
                              label: "结束时间",
                              width: "160",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": true,
                              label: "状态",
                              width: "140",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm._v(
                                        _vm._s(
                                          _vm.translateInstanceStatus(
                                            scope.row.status
                                          )
                                        )
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3165669011
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": true,
                              prop: "result",
                              label: "任务结果",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }